import { render, staticRenderFns } from "./product-include-edit.vue?vue&type=template&id=1f9c1ac0&"
import script from "./product-include-edit.vue?vue&type=script&lang=js&"
export * from "./product-include-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports